var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-overlay", { attrs: { show: _vm.loading } }, [
    _c(
      "div",
      {
        staticClass:
          "h-screen flex w-full bg-img vx-row no-gutter items-center justify-center",
        style: {
          "background-image": "url(" + _vm.imagenFondo + ") !important",
          "background-attachment": "fixed",
          overflow: "scroll"
        },
        attrs: { id: "management" }
      },
      [
        _c(
          "div",
          [
            _vm.ingresoLogo
              ? _c("img", {
                  style: _vm.logoStyle,
                  attrs: {
                    src: _vm.ingresoLogo.imagen,
                    id: "logo",
                    alt: "logo"
                  }
                })
              : _vm._e(),
            _vm.provider === "esign7"
              ? [
                  _c("h4", { staticClass: "mb-5 text-white text-center" }, [
                    _vm._v(" Verificación de identidad para Esign7 ")
                  ]),
                  _c(
                    "b-card",
                    [
                      _c("verification-form-external", {
                        attrs: { cuUserData: _vm.cuUserData }
                      })
                    ],
                    1
                  )
                ]
              : _vm._e(),
            _vm.provider === "signapi"
              ? [
                  _c("h4", { staticClass: "mb-5 text-white text-center" }, [
                    _vm._v(" Verificación de identidad ")
                  ]),
                  _c("b-card", { staticStyle: { "min-width": "450px" } }, [
                    !_vm.verificationStarted
                      ? _c("div", [
                          _c("div", { staticClass: "text-center mb-4" }, [
                            _c("p", { staticClass: "mb-2" }, [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.cuUserData.name) +
                                    " " +
                                    _vm._s(_vm.cuUserData.lastName)
                                )
                              ])
                            ]),
                            _c("p", { staticClass: "text-muted" }, [
                              _vm._v("RUT: " + _vm._s(_vm.cuUserData.iut))
                            ])
                          ]),
                          _c("p", { staticClass: "text-center mb-4" }, [
                            _vm._v(
                              " Seleccione el método de verificación de identidad para generar su certificado de firma electrónica avanzada. "
                            )
                          ]),
                          _c("div", { staticClass: "row px-3" }, [
                            _vm.nfcEnabled
                              ? _c(
                                  "div",
                                  { staticClass: "col-12 mb-4" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          variant: "primary",
                                          block: "",
                                          size: "lg"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.startVerification("NFC")
                                          }
                                        }
                                      },
                                      [
                                        _c("feather-icon", {
                                          staticClass: "mr-2",
                                          attrs: { icon: "SmartphoneIcon" }
                                        }),
                                        _vm._v(" Verificación por NFC ")
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "bg-light rounded p-3 mt-2",
                                        staticStyle: {
                                          "border-left": "3px solid #7367f0"
                                        }
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass: "mb-1",
                                            staticStyle: {
                                              color: "#4e4e4e",
                                              "font-size": "0.85rem"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " Se deberá descargar una aplicación para realizar una verificación de identidad con su dispositivo móvil. "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticClass: "mb-0",
                                            staticStyle: {
                                              color: "#4e4e4e",
                                              "font-size": "0.85rem"
                                            }
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                "Su dispositivo debe contar con sensor NFC para continuar con esta opción."
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.bankTransferEnabled
                              ? _c(
                                  "div",
                                  { staticClass: "col-12 mb-3" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          variant: "outline-primary",
                                          block: "",
                                          size: "lg"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.startVerification(
                                              "BANK_TRANSFER"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("feather-icon", {
                                          staticClass: "mr-2",
                                          attrs: { icon: "DollarSignIcon" }
                                        }),
                                        _vm._v(
                                          " Verificación por Transferencia bancaria "
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "bg-light rounded p-3 mt-2",
                                        staticStyle: {
                                          "border-left": "3px solid #7367f0"
                                        }
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass: "mb-1",
                                            staticStyle: {
                                              color: "#4e4e4e",
                                              "font-size": "0.85rem"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " Se debe realizar una transferencia bancaria desde una cuenta a su nombre. "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticClass: "mb-1",
                                            staticStyle: {
                                              color: "#4e4e4e",
                                              "font-size": "0.85rem"
                                            }
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                "El RUT del titular de la cuenta debe ser igual a " +
                                                  _vm._s(_vm.cuUserData.iut) +
                                                  "."
                                              )
                                            ])
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticClass: "mb-0",
                                            staticStyle: {
                                              color: "#4e4e4e",
                                              "font-size": "0.85rem"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " El monto será reversado una vez confirmada su identidad. "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        ])
                      : _vm._e(),
                    _vm.verificationStarted
                      ? _c(
                          "div",
                          { staticClass: "text-center" },
                          [
                            _vm.verificationFailed
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "mb-4" },
                                    [
                                      _c("feather-icon", {
                                        staticClass: "text-danger",
                                        attrs: {
                                          icon: "XCircleIcon",
                                          size: "48"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("h5", { staticClass: "text-danger" }, [
                                    _vm._v("Verificación fallida")
                                  ]),
                                  _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        color: "#4e4e4e",
                                        "font-size": "0.95rem"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " No fue posible verificar su identidad. Esto puede ocurrir si los datos ingresados no coinciden o si hubo un problema con el proceso de verificación. "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "bg-light rounded p-3 mb-3 text-left",
                                      staticStyle: {
                                        "border-left": "3px solid #ea5455"
                                      }
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "mb-1",
                                          staticStyle: {
                                            color: "#4e4e4e",
                                            "font-size": "0.85rem"
                                          }
                                        },
                                        [
                                          _c("strong", [_vm._v("Importante:")]),
                                          _vm._v(
                                            " El sistema permite un máximo de 3 intentos de verificación cada 24 horas. Si ha agotado sus intentos, deberá esperar antes de volver a intentarlo. "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        color: "#4e4e4e",
                                        "font-size": "0.95rem"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " Si el problema persiste, contacte a soporte para obtener asistencia. "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "mt-4" },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: { variant: "primary" },
                                          on: { click: _vm.retryVerification }
                                        },
                                        [
                                          _c("feather-icon", {
                                            staticClass: "mr-1",
                                            attrs: { icon: "RefreshCwIcon" }
                                          }),
                                          _vm._v(" Intentar nuevamente ")
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              : _vm.verificationMethod === "NFC"
                              ? [
                                  _vm.loadingQuestions
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "mb-4" },
                                          [
                                            _c("feather-icon", {
                                              staticClass: "text-success",
                                              attrs: {
                                                icon: "CheckCircleIcon",
                                                size: "48"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c("h5", [
                                          _vm._v("Identidad verificada por NFC")
                                        ]),
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              color: "#4e4e4e",
                                              "font-size": "0.95rem"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " Estamos solicitando las preguntas de verificación. Espere un momento. "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "mt-3" },
                                          [
                                            _c("b-spinner", {
                                              attrs: {
                                                variant: "primary",
                                                label: "Cargando preguntas..."
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    : _vm.showSecurityQuestions
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "text-left" },
                                          [
                                            _c("h5", { staticClass: "mb-3" }, [
                                              _vm._v(
                                                "Preguntas de verificación de identidad"
                                              )
                                            ]),
                                            _c(
                                              "p",
                                              {
                                                staticClass: "mb-4",
                                                staticStyle: {
                                                  color: "#4e4e4e",
                                                  "font-size": "0.9rem"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " Su identidad fue verificada por NFC. Responda las siguientes preguntas para completar el proceso. "
                                                )
                                              ]
                                            ),
                                            _vm._l(
                                              _vm.securityQuestions,
                                              function(pregunta, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass: "mb-4"
                                                  },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "font-weight-bold",
                                                        staticStyle: {
                                                          color: "#4e4e4e"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              pregunta.questionText ||
                                                                pregunta.question ||
                                                                pregunta.text ||
                                                                pregunta
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    ),
                                                    pregunta.answerChoice ||
                                                    pregunta.options ||
                                                    pregunta.alternatives
                                                      ? _c(
                                                          "b-form-radio-group",
                                                          {
                                                            staticClass: "mt-2",
                                                            attrs: {
                                                              options: _vm.formatQuestionOptions(
                                                                pregunta.answerChoice ||
                                                                  pregunta.options ||
                                                                  pregunta.alternatives
                                                              ),
                                                              stacked: ""
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .securityAnswers[
                                                                  index
                                                                ],
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.securityAnswers,
                                                                  index,
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "securityAnswers[index]"
                                                            }
                                                          }
                                                        )
                                                      : _c("b-form-input", {
                                                          staticClass: "mt-2",
                                                          attrs: {
                                                            placeholder:
                                                              "Ingrese su respuesta"
                                                          },
                                                          model: {
                                                            value:
                                                              _vm
                                                                .securityAnswers[
                                                                index
                                                              ],
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.securityAnswers,
                                                                index,
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "securityAnswers[index]"
                                                          }
                                                        })
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text-right mt-4"
                                              },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    attrs: {
                                                      variant: "primary",
                                                      disabled:
                                                        !_vm.allSecurityQuestionsAnswered ||
                                                        _vm.loading
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.submitSecurityAnswers
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Verificar y generar certificado "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          2
                                        )
                                      ]
                                    : _vm.certificateQueued
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "mb-4" },
                                          [
                                            _c("feather-icon", {
                                              staticClass: "text-warning",
                                              attrs: {
                                                icon: "ShieldIcon",
                                                size: "48"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c("h5", [
                                          _vm._v(
                                            "Generando certificado de firma"
                                          )
                                        ]),
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              color: "#4e4e4e",
                                              "font-size": "0.95rem"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " Sus respuestas fueron validadas correctamente. Estamos generando su certificado de firma electrónica avanzada. "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              color: "#4e4e4e",
                                              "font-size": "0.95rem"
                                            }
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v("No cierre esta página.")
                                            ]),
                                            _vm._v(
                                              " Será redirigido automáticamente en unos segundos. "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "mt-3" },
                                          [
                                            _c("b-spinner", {
                                              attrs: {
                                                variant: "warning",
                                                label:
                                                  "Generando certificado..."
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    : [
                                        _c(
                                          "div",
                                          { staticClass: "mb-3" },
                                          [
                                            _c("feather-icon", {
                                              staticClass: "text-primary",
                                              attrs: {
                                                icon: "SmartphoneIcon",
                                                size: "42"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c("h5", [
                                          _vm._v("Verificación NFC en proceso")
                                        ]),
                                        _c("div", { staticClass: "my-4" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-inline-block rounded-circle border border-primary p-3",
                                              staticStyle: {
                                                width: "100px",
                                                height: "100px",
                                                "line-height": "70px"
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "font-weight-bold",
                                                  staticStyle: {
                                                    "font-size": "1.5rem",
                                                    color: "#7367f0"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.countdownFormatted
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-muted mt-2 small"
                                            },
                                            [
                                              _vm._v(
                                                "Tiempo restante para completar la verificación"
                                              )
                                            ]
                                          )
                                        ]),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "bg-light rounded p-3 mb-4 text-left",
                                            staticStyle: {
                                              "border-left": "3px solid #7367f0"
                                            }
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "mb-2",
                                                staticStyle: {
                                                  color: "#4e4e4e",
                                                  "font-size": "0.9rem"
                                                }
                                              },
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    "Descargue la aplicación Firmaki ID"
                                                  )
                                                ]),
                                                _vm._v(
                                                  " en su celular para completar la verificación NFC con su cédula de identidad. "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c("div", { staticClass: "row mt-3" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col-6 text-center"
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "btn btn-outline-dark btn-block",
                                                  attrs: {
                                                    href:
                                                      "https://apps.apple.com/cl/app/firmaki-id/id6756390157",
                                                    target: "_blank"
                                                  }
                                                },
                                                [
                                                  _c("feather-icon", {
                                                    staticClass: "mr-1",
                                                    attrs: {
                                                      icon: "SmartphoneIcon",
                                                      size: "14"
                                                    }
                                                  }),
                                                  _vm._v(" App Store (iPhone) ")
                                                ],
                                                1
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col-6 text-center"
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "btn btn-outline-success btn-block",
                                                  attrs: {
                                                    href:
                                                      "https://play.google.com/store/apps/details?id=id.amparo.firmaki",
                                                    target: "_blank"
                                                  }
                                                },
                                                [
                                                  _c("feather-icon", {
                                                    staticClass: "mr-1",
                                                    attrs: {
                                                      icon: "SmartphoneIcon",
                                                      size: "14"
                                                    }
                                                  }),
                                                  _vm._v(
                                                    " Google Play (Android) "
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm.countdownExpired
                                          ? _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "text-danger mt-4 font-weight-bold"
                                              },
                                              [
                                                _vm._v(
                                                  " El tiempo ha expirado. Por favor, inicie el proceso nuevamente. "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                ]
                              : [
                                  _vm.certificateQueued
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "mb-4" },
                                          [
                                            _c("feather-icon", {
                                              staticClass: "text-warning",
                                              attrs: {
                                                icon: "ShieldIcon",
                                                size: "48"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c("h5", [
                                          _vm._v(
                                            "Generando certificado de firma"
                                          )
                                        ]),
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              color: "#4e4e4e",
                                              "font-size": "0.95rem"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " Su identidad fue verificada correctamente. Estamos generando su certificado de firma electrónica avanzada. "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              color: "#4e4e4e",
                                              "font-size": "0.95rem"
                                            }
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v("No cierre esta página.")
                                            ]),
                                            _vm._v(
                                              " Será redirigido automáticamente en unos segundos. "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "mt-3" },
                                          [
                                            _c("b-spinner", {
                                              attrs: {
                                                variant: "warning",
                                                label:
                                                  "Generando certificado..."
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    : [
                                        _c(
                                          "div",
                                          { staticClass: "mb-4" },
                                          [
                                            _c("feather-icon", {
                                              staticClass: "text-primary",
                                              attrs: {
                                                icon: "ClockIcon",
                                                size: "48"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c("h5", [
                                          _vm._v("Verificación en proceso")
                                        ]),
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              color: "#4e4e4e",
                                              "font-size": "0.95rem"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " Estamos verificando su transferencia bancaria. Este proceso puede demorar unos segundos. "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              color: "#4e4e4e",
                                              "font-size": "0.95rem"
                                            }
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v("No cierre esta página.")
                                            ]),
                                            _vm._v(
                                              " Será redirigido automáticamente una vez confirmada su identidad. "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "mt-3" },
                                          [
                                            _c("b-spinner", {
                                              attrs: {
                                                variant: "primary",
                                                label: "Verificando..."
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                ]
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                ]
              : _vm._e()
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }